import { CSSObject, Link } from '@ritualco/jutsu'
import { Link as RouterLink, LinkProps } from 'lib/router'
import { ReactComponent as HelpIcon } from 'assets/Icons/Help.svg'
import { ReactNode } from 'react'

type SettingCard = {
  icon: ReactNode
  title: string
  description: string
  content: string
}

export const SettingsLink = (props: LinkProps) => (
  <Link as={RouterLink} {...props} py="1" fontSize="small" />
)

export const cardStyle: CSSObject = {
  p: 6,
  paddingBottom: 13,
  border: '1px solid',
  borderColor: 'grayscale.quinary',
  borderRadius: 'lg',
}

export const getSettingsSections = (contentfulId: string): SettingCard[] => [
  {
    icon: <HelpIcon />,
    title: 'pmportal.settings.settingsCardTitle',
    description: 'pmportal.settings.settingsCardDescription',
    content: contentfulId,
  },
  {
    icon: <HelpIcon />,
    title: 'pmportal.settings.helpCardTitle',
    description: 'pmportal.settings.helpCardDescription',
    content: 'pmportal.settings.helpCardContent',
  },
  {
    icon: <HelpIcon />,
    title: 'pmportal.settings.billingCardTitle',
    description: 'pmportal.settings.billingCardDescription',
    content: 'pmportal.settings.billingCardContent',
  },
  {
    icon: <HelpIcon />,
    title: 'pmportal.settings.profileCardTitle',
    description: 'pmportal.settings.profileCardDescription',
    content: 'pmportal.settings.profileCardContent',
  },
]
